export default __webpack_public_path__ + "static/media/rogi_two.121898e2.png";